// Environment configuration — single source for all environment-dependent values
export const API_BASE = import.meta.env.VITE_API_BASE || 'https://magicshop-emilagam.waw0.amvera.tech';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || 'https://5d47be9d2ea5e2adec629f75ed356c01@o1090902.ingest.us.sentry.io/4511026699501568';
// NOTE: these still point at the selebrus bots. A skazki-specific (магазинчудес)
// Telegram/MAX bot may be needed — override via VITE_TELEGRAM_BOT_USERNAME / VITE_MAX_BOT_URL.
export const TELEGRAM_BOT_USERNAME = import.meta.env.VITE_TELEGRAM_BOT_USERNAME || 'selebrusbot';
export const MAX_BOT_URL = import.meta.env.VITE_MAX_BOT_URL || 'https://max.ru/id366230024081_bot';
